// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SrHg","col":"styles_col__3CHAj"};